import { createContext } from 'preact';

export const I18n = createContext({});
export const Config = createContext({});
export const Theme = createContext('light');
export const Tracking = createContext({});
